export default __webpack_public_path__ + "static/media/White Hand Fists.42022f24.jpg";